import { ENDPOINTS } from "@/constants/endpoints"
import { QUERY_KEYS } from "@/constants/queryKeys"
import { useGenericQuery } from "@/hooks/useGenericQuery"
import type { Settings } from "@/types/settingsTypes"

export const useSettingsData = () => {
  return useGenericQuery<Settings>({
    keys: QUERY_KEYS.settings.index(),
    apiEndpoint: ENDPOINTS.settings.index(),
  })
}
